
















import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import AdminCouponIndexPageActions from '@/modules/coupon/components/admin/table/AdminCouponIndexPageActions.vue'
import AdminCouponStatus from '@/modules/coupon/components/admin/AdminCouponStatus.vue'
import { InjectReactive } from 'vue-property-decorator'
import TextWrapper from '@/modules/shared/components/shared/TextWrapper.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminCouponIndexPageTableRow extends mixins<TesTableRow>(TesTableRow) {
  @InjectReactive() couponFixedData

  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    status: {
      component: AdminCouponStatus,
      handler: (value, row, fixedData) => ({ couponStatus: value, couponStatusInPersian: fixedData.statuses })
    },
    type: {
      component: TextWrapper,
      handler: (value, row, fixedData) => ({ text: fixedData.types[value] })
    },
    actions: {
      component: AdminCouponIndexPageActions,
      handler: (value, row) => ({ couponId: row.id })
    }
  }
}
